/** Encode each path segment, keeping slashes and query/hash intact. */
const encodePathSegments = (path) => {
  if (!path) return "";
  return path
    .split("/")
    .map((segment) => {
      if (!segment) return "";
      try {
        return encodeURIComponent(decodeURIComponent(segment));
      } catch {
        return encodeURIComponent(segment);
      }
    })
    .join("/");
};

const encodeStaticUrl = (url) => {
  if (!url) return "";
  const normalized = String(url);
  try {
    if (normalized.includes("://")) {
      const parsed = new URL(normalized);
      parsed.pathname = encodePathSegments(parsed.pathname);
      return parsed.toString();
    }
  } catch {
    // fall through
  }

  const hashIndex = normalized.indexOf("#");
  const queryIndex = normalized.indexOf("?");
  let path = normalized;
  let rest = "";

  if (queryIndex >= 0 && (hashIndex < 0 || queryIndex < hashIndex)) {
    path = normalized.slice(0, queryIndex);
    rest = normalized.slice(queryIndex);
  } else if (hashIndex >= 0) {
    path = normalized.slice(0, hashIndex);
    rest = normalized.slice(hashIndex);
  }

  return `${encodePathSegments(path)}${rest}`;
};

const getUrlForStaticApi = (url) => {
  if (!url) return "";
  const normalized = String(url);
  if (normalized.includes("http://") || normalized.includes("https://")) {
    return encodeStaticUrl(normalized);
  }
  const base = String(process.env.REACT_APP_STATIC_API || "").replace(/\/$/, "");
  const path = normalized.startsWith("/") ? normalized : `/${normalized}`;
  return encodeStaticUrl(`${base}${path}`);
};

/** Same-origin URL for fetch in dev (CRA proxy) to avoid CORS on static API. */
const getFetchableStaticUrl = (url) => {
  const fullUrl = getUrlForStaticApi(url);
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return fullUrl;
  }

  const staticApi = String(process.env.REACT_APP_STATIC_API || "").replace(/\/$/, "");
  if (staticApi && fullUrl.startsWith(staticApi)) {
    return `/static-api-proxy${fullUrl.slice(staticApi.length)}`;
  }

  return fullUrl;
};

export {
  getUrlForStaticApi,
  getFetchableStaticUrl,
};
